export default __webpack_public_path__ + "static/media/hartwig-logo.188fe601.svg";